import * as THREE from "three";
import type { VfxAtlasMeta } from "../../../../art/vfx.js";
import { AssetLibrary } from "./assets";

/**
 * The VFX sprite atlas (2048², 16 MB decoded), loaded once for the page (M33). The level's effects, the hub's and the
 * end screen's chest each loaded their own copy, so the end screen held two decoded images of it at once beside two
 * GPU copies. Each caller still gets a texture of its own (a WebGL context cannot share one, and each disposes its own),
 * made from the one image.
 */
let pending: Promise<{ meta: VfxAtlasMeta; image: HTMLImageElement }> | null = null;

export async function loadVfxAtlas(): Promise<{ meta: VfxAtlasMeta; texture: THREE.Texture }> {
  const job = pending ??= (async () => {
    const meta = (await (await fetch(AssetLibrary.resolveInlined("./vfx/vfx_atlas.json"))).json()) as VfxAtlasMeta;
    const image = await new THREE.ImageLoader().loadAsync(AssetLibrary.resolveInlined("./vfx/vfx_atlas.png"));
    return { meta, image };
  })();
  try {
    const { meta, image } = await job;
    const texture = new THREE.Texture(image);
    texture.needsUpdate = true;
    return { meta, texture };
  } catch (err) {
    if (pending === job) pending = null;                      // offline or a failed read: the next caller tries again
    throw err;
  }
}
